import { useState } from 'react'

export interface ObservableEvent {
  subscribe: Function
  emitter: Function
}

const useObservable = (): ObservableEvent => {
  const [callbacks, setCallbacks] = useState<Function[]>([])

  const subscribe = (callback: Function) =>
    setCallbacks((prevCallbacks: Function[]) => {
      return [...prevCallbacks, callback]
    })

  const emitter = (index?: number | null, value?: any) => {
    /* istanbul ignore else */
    if (index !== null && index !== undefined && callbacks[index]) {
      callbacks[index](value)
    }
  }

  return {
    subscribe,
    emitter,
  }
}

export default useObservable
